import React, { useState } from "react";
import Table from "./Table";
import AddHotel from "./AddCities";
import "./style.css";
import MessageProvider from "./Context";

const Cities = () => {
    const [isWaiting, setIsWaiting] = useState(false);
    const [regiondata, setRegiondata] = useState(false);
    return (
        <div className="container py-5">
            {isWaiting && <div className="ca-overlay"></div>}
            <MessageProvider>
                <AddHotel regiondata={regiondata}/>
                <Table setIsWaiting={setIsWaiting} setRegiondata={setRegiondata}/>
            </MessageProvider>
        </div>
    );
};

export default Cities;
